
export const NullString = (value) => {
    return !value || value === null ? "" : value;
}

export const NullSelect = (value) => {
    return !value || value === null ? "N" : value;
}

export const NullInt = (value) => {
    return !value || value === null ? 0 : value;
}

export const ZeroToNull = (value) => {
    return !value || value === 0 ? "" : value;
}

